export const getFileNameFromFile = (filePath: string): string => {
  // This method works for filenames with or without extensions.
  // split('/').pop() → Removes any preceding path if present.
  // split('\\').pop() → Handles Windows-style paths.
  const fileNameWithExt = filePath.split('/').pop()?.split('\\').pop();

  if (!fileNameWithExt) return ''; // Handle undefined case safely

  // split('.') → Splits the filename and extension.
  // slice(0, -1).join('.') → Removes the extension and reassembles the filename (in case of multiple dots in the name).
  return fileNameWithExt.split('.').slice(0, -1).join('.') || fileNameWithExt;
};
